import React, { useEffect, useState } from "react";
import filteringProps from "../filtering/flags.json";
import sortingProps from "../sorting/flags.json";
import { DataForm, DataTable, DataTableField } from "../../../../components/data/DataTable";
import { API_ROUTES } from '../../../../core/Constants';
import { getUser, hasRole, setPage, setToolbarActions, toPrettyDate, useHub } from '../../../../core/Global';
import Modal from "../../../../components/base/Modal";
import { DrawerForm } from "../../../../components/drawers/DrawerForm";
import { toastSuccess } from "../../../../components/base/Toast";
import Icon from "../../../../components/base/Icon";
import FlexRow from "../../../../components/base/FlexRow";
import Tagify from "../../../../components/tagify/Tagify";
import { Link } from "react-router-dom";
import { ListItem } from "../../../../core/Types";
import TextBox from "../../../../components/form/TextBox";
import DataItem from "../../../../models/DataItem";
import DropDown from "../../../../components/form/DropDown";
import PhoneNumberSelect from "../../../../components/form/PhoneNumberSelect";
import ToggleSwitch from "../../../../components/form/ToggleSwitch";
import ModalUpdateJobRates from "../../../../components/modals/ModalUpdateJobRates";
import JobSource from "../models/JobSource";
import DataTableActiveToggle from "../../../../components/data/DataTableActiveToggle";
import DatePicker from "../../../../components/form/DatePicker";
import TechPoolSelector from "../components/TechPoolSelector";
import AvatarUploade from "../../../../components/form/AvatarUploade";

function JobSourcesList() {

  const hub = useHub();
  const user = getUser();

  const [createModal, createModalSet] = useState<boolean>(false);
  const [editModal, editModalSet] = useState<boolean>(false);
  const [deleteModal, deleteModalSet] = useState<boolean>(false);

  const [selectedItem, selectedItemSet] = useState<JobSource>();

  // PhoneNumberSelect posts no form control of its own, so the chosen line is held here and
  // merged into the body on submit. Empty means "no override", so neither drawer preselects.
  const [addForceLineId, addForceLineIdSet] = useState<string>();
  const [editForceLineId, editForceLineIdSet] = useState<string>();

  const [refresh, refreshSet] = useState<boolean>();
  const [groupsRouteParams, groupsRouteParamsSet] = useState<ListItem[]>([]);
  const [systemStatus, systemStatusSet] = useState<boolean>();

  const [techsModal, techsModalSet] = useState<boolean>(false);
  const [techIds, techIdsSet] = useState<string[]>();
  const [priorityTechIds, priorityTechIdsSet] = useState<string[]>();


  const [sourceTypes] = useState<DataItem[]>([
    {
      id: "1",
      name: "External Company"
    },
    {
      id: "2",
      name: "Advertisement"
    }
  ])



  const add = () => {
    addForceLineIdSet(undefined);
    createModalSet(true);
  }

  const edit = (data: any) => {
    selectedItemSet(data);
    editForceLineIdSet(data?.forceProxyLineId);
    updateOldRatesSet(false);
    editModalSet(true);
  }

  const deleteSource = (data: any) => {
    selectedItemSet(data);
    deleteJobsCountSet(undefined);
    deleteModalSet(true);
    hub.Get(API_ROUTES.JobSources + "jobscount/" + data?.id, res => {
      if (res.success) deleteJobsCountSet(Number.parseInt(res.data.jobsCount) || 0);
    })
  }

  const TechsItem = (data: JobSource) => {
    const count = data.techs?.length ?? 0
    return (
      <a href="#" className={"d-flex align-items-center" + (count > 0 ? "" : " text-gray-500 fs-8")}
        onClick={e => {
          e.preventDefault();
          selectedItemSet(data);
          techsModalSet(true)
        }}>
        {
          count > 0
            ?
            <>
              <Icon icon="user-helmet-safety" className="me-2" size={13} />
              <span>{count} {count > 1 ? "Technicians" : "Technician"}</span>
            </>
            :
            <span>[Assign Technician]</span>
        }
      </a>
    )
  }

  const NameItem = (data: JobSource) => (
    <FlexRow>
      <img src={data.logoUrl ? data.logoUrl : "/assets/media/blanks/rinvox.png"} alt=""
        className="w-50px h-50px rounded me-2"
        style={{ objectFit: "contain" }}
        onError={e => { (e.target as HTMLImageElement).src = "/assets/media/blanks/rinvox.png" }} />
      <div>
        {data.name}
      </div>
      <a href="#" className="ms-1"
        onClick={e => {
          e.preventDefault();
          edit(data);
        }}>
        <Icon icon="edit" className="ms-2" size={12} />
      </a>
    </FlexRow>
  )

  const JobsCount = (data: JobSource) => (
    <div>
      {
        (data.activeJobsCount ?? 0) > 0 ?
          <a href={"/crm/jobs?jobSources=" + data.id} target="_blank">
            {data.activeJobsCount}
          </a>
          :
          <div>
            0
          </div>
      }

    </div>
  )

  const RatesItem = (data: any) => (
    <div>
      {data.rate}%
    </div>
  )
  const FeeItem = (data: any) => (
    <div>
      {data.fee}$
    </div>
  )

  const UserItem = (data: any) => (
    <div>
      <div>
        {data.ownerUser?.fullName ?? "System Source"}
      </div>
      {
        data.creatorUser &&
        <div className='d-flex align-items-center fs-8 mt-1'>
          <Icon icon="user" className="me-1" size={12} />
          <span>
            created by: {data.creatorUser?.username}
          </span>
        </div>
      }
    </div>
  )

  const SourceTypeItem = (data: any) => (
    <div>
      {
        data.sourceType == 1 ?
          <FlexRow>
            <Icon icon="briefcase" className="me-1 text-gray-800" type="solid" />
            <div className="fs-8">
              External Company
            </div>
          </FlexRow>
          : data.sourceType == 2 ?
            <FlexRow>
              <Icon icon="bullhorn" className="me-1 text-gray-800" type="solid" />
              <div className="fs-8">
                Advertisement
              </div>
            </FlexRow>
            : <></>
      }

    </div>
  )

  const CreatedItem = (data: JobSource) => (
    <div>
      <div className='d-flex align-items-center'>
        {toPrettyDate(data.createdAt)}
      </div>
      {
        data.creatorUser &&
        <FlexRow className='fs-8 text-gray-600 mt-1'>
          <div>
            <Icon icon="user" className="me-2" size={10} type="solid" />
          </div>
          <div className="fs-8">
            By: {data.creatorUser.fullName}
          </div>
        </FlexRow>
      }

    </div>
  )


  useEffect(() => {
    setPage("Job Sources", "CRM", "Base Data");
  }, [])

  useEffect(() => {
    if (refresh) {
      setTimeout(() => {
        refreshSet(false);
      }, 1000);
    }
  }, [refresh])


  const [confirmRequired, confirmRequiredSet] = useState<boolean>();
  const [updateRequired, updateRequiredSet] = useState<boolean>();
  const [updateRate, updateRateSet] = useState<any>();
  const [updateJobs, updateJobsSet] = useState<string[]>();
  const [confirmed, confirmedSet] = useState<boolean>();


  useEffect(() => {
    if (confirmed && updateJobs) {
      $("#drawer-edit-source-submit").click();
    }
  }, [confirmed])


  const [editedRate, editedRateSet] = useState<number>();
  const [updateOldRates, updateOldRatesSet] = useState<boolean>(false);

  // The list carries a stored jobsCount that never counted archived jobs, so a source holding
  // hundreds of them can look empty. The delete dialog asks the server for the real number before
  // deciding whether to demand a destination source.
  const [deleteJobsCount, deleteJobsCountSet] = useState<number>();

  useEffect(() => {
    editedRateSet(selectedItem?.rate)
  }, [selectedItem])


  return (
    <>

        <DataTable
          objectName="Source"
          apiRoute={API_ROUTES.JobSources}
          filteringProps={filteringProps}
          sortingProps={sortingProps}
          edit editCustom={edit} addCustom={add}
          delete={hasRole("DeleteJobSources")} deleteCustom={deleteSource}
          refresh={refresh}>
          <DataTableField title="" width={50}>
            <DataTableActiveToggle route={API_ROUTES.JobSources} />
          </DataTableField>
          <DataTableField title="Name">
            <NameItem />
          </DataTableField>
          <DataTableField title="Type">
            <SourceTypeItem />
          </DataTableField>
          <DataTableField title="Rate">
            <RatesItem />
          </DataTableField>
          <DataTableField title="Fee">
            <FeeItem />
          </DataTableField>
          <DataTableField title="Technicians">
            <TechsItem />
          </DataTableField>
          <DataTableField title="" hidden={!user?.isSuperAdmin}>
            <UserItem />
          </DataTableField>
          <DataTableField title="Created">
            <CreatedItem />
          </DataTableField>
        </DataTable>

      {
        createModal &&
        <DrawerForm id="drawer-add-source" permanent size="medium"
          title="Create Job Source"
          buttonText="Add Source"
          onOpen={() => $("#txt-add-sourcename").focus()}
          onClose={() => createModalSet(false)}
          onSubmit={(body, callback) => {

            var valid = true;
            var focus = true;

            if (window.isNullOrEmpty(body.type)) {
              window.formError("type", "Please select a source type!", "drawer-add-source", focus);
              valid = false;
              focus = false;
            }

            if (window.isNullOrEmpty(body.name) || body.name.length < 2) {
              window.formError("name", "Please write a valid name!", "drawer-add-source", focus);
              valid = false;
              focus = false;
            }

            if (!valid) {
              if (callback) callback();
              return;
            }

            hub.Post(API_ROUTES.JobSources, { ...body, forceLineId: addForceLineId }, res => {
              if (res.success) {
                refreshSet(true);
                toastSuccess("Job Source has been added successfully!");
              }
              if (callback) callback(res);
            })

          }}>
          <div>
            {
              user?.isSuperAdmin &&
              <>
                <div className="fs-7 fw-bold">
                  Assign to
                  <span className="small text-muted mx-2">
                    Leave it blank to create system source!
                  </span>
                </div>
                <Tagify name="ownerUserId" id="drp-ownerUserId" placeholder="Select a Customer" apiUrl={API_ROUTES.TagifyCustomers} single block />
              </>
            }

            <div className="mb-5">
              <AvatarUploade preventCrop type="logos" name="logo" width={100} label="Logo" />
            </div>

            <DropDown name="type" source={sourceTypes} label="Source Type*" labelUp block parentModal="drawer-add-source" />
            <TextBox id="txt-add-sourcename" name="name" label="Source Name*" labelUp block />
            <PhoneNumberSelect name="forceLineId" label="Default Phone for Extensions" labelUp block deselect
              value={addForceLineId} onChange={addForceLineIdSet} />
            <TextBox name="rate" label="Default Rate" labelUp block percent icon="percent" />

            <TextBox name="fee" label="Source Fee" labelUp block money icon="dollar-sign" />
            <ToggleSwitch name="calculateAsCash" label="Calculate as Cash" raw small />

          </div>
        </DrawerForm>
      }

      {
        editModal &&
        <DrawerForm id="drawer-edit-source" permanent size="medium"
          title="Edit Job Source"
          buttonText="Update Source"
          onOpen={() => $("#txt-edit-sourcename").focus()}
          onClose={() => editModalSet(false)}
          onSubmit={(body, callback) => {

            var valid = true;
            var focus = true;

            if (window.isNullOrEmpty(body.type)) {
              window.formError("type", "Please select a source type!", "drawer-edit-source", focus);
              valid = false;
              focus = false;
            }

            if (window.isNullOrEmpty(body.name) || body.name.length < 2) {
              window.formError("name", "Please write a valid name!", "drawer-edit-source", focus);
              valid = false;
              focus = false;
            }

            if (!valid) {
              if (callback) callback();
              return;
            }

            updateRateSet(body.rate);

            var jobIds = "";
            updateJobs?.forEach(j => {
              if (jobIds != "") jobIds += ",";
              jobIds += j;
            });

            hub.Put(API_ROUTES.JobSources + selectedItem?.id, {
              ...body,
              forceLineId: editForceLineId,
              updateJobs: jobIds
            }, res => {
              confirmedSet(false);
              updateRequiredSet(false);
              if (res.success) {
                if (res.confirmRequired) {
                  updateRequiredSet(true);
                  if (callback) callback();
                  return;
                }
                refreshSet(true);
                toastSuccess("Job Source has been updated successfully!");
              }
              if (callback) callback(res);
            })

          }}>
          <div>
            {
              user?.isSuperAdmin &&
              <>
                <div className="fs-7 fw-bold">
                  Assign to
                  <span className="small text-muted mx-2">
                    Leave it blank to create system source!
                  </span>
                </div>
                <Tagify name="ownerUserId" id="drp-ownerUserId" placeholder="Select a Customer" apiUrl={API_ROUTES.TagifyCustomers} single block />
              </>
            }

            <div className="mb-5">
              <AvatarUploade preventCrop type="logos" name="logo" width={100} label="Logo"
                defaultValue={selectedItem?.logo} imageUrl={selectedItem?.logoUrl} />
            </div>

            <DropDown name="type" source={sourceTypes} label="Source Type*" labelUp block parentModal="drawer-edit-source" defaultValue={selectedItem?.sourceType?.toString()} />
            <TextBox id="txt-edit-sourcename" name="name" label="Source Name*" labelUp block value={selectedItem?.name} />
            <PhoneNumberSelect name="forceLineId" label="Default Phone for Extensions" labelUp block deselect
              value={editForceLineId} onChange={editForceLineIdSet} />

            <TextBox name="rate" label="Default Rate" labelUp block percent
              icon="percent" value={selectedItem?.rate?.toString()}
              onTextChanges={t => editedRateSet(Number.parseInt(t))} />

            <TextBox name="fee" label="Source Fee" labelUp block money icon="dollar-sign" value={selectedItem?.fee?.toString()} />
            <ToggleSwitch name="calculateAsCash" label="Calculate as Cash" raw small checked={selectedItem?.calculateAsCash} />

            {
              editedRate !== selectedItem?.rate &&
              <div className="mt-5">
                <ToggleSwitch name="updateRates" label="Update rates for already closed jobs!" raw small
                  onChange={e => updateOldRatesSet(e)} />

                {
                  updateOldRates &&
                  <div className="my-5">
                    <DatePicker id="dt-pick-oldrates-from" name="oldratesFrom"
                      label="Update Jobs From" drops="up" labelUp icon="calendar" />
                  </div>
                }
              </div>
            }

          </div>
        </DrawerForm>
      }

      {
        techsModal && selectedItem &&
        <DrawerForm id="drawer-jobsource-techs"
          title={`${selectedItem?.name}: Technicians`}
          size="xlarge"
          buttonText="Update Technicians"
          onClose={() => {
            selectedItemSet(undefined)
            techsModalSet(false)
          }}
          onSubmit={(body, callback) => {
            hub.Post(API_ROUTES.JobSources + "techs", {
              id: selectedItem.id,
              techIds: techIds,
              priorityTechIds: priorityTechIds
            }, res => {
              if (res.success) refreshSet(true)
              callback?.(res)
            })
          }}
        >
          <TechPoolSelector selectedTechIds={selectedItem.techIds}
            priorityTechIds={selectedItem.priorityTechIds}
            onChange={ids => techIdsSet(ids)}
            onPriorityChange={ids => priorityTechIdsSet(ids)} />
        </DrawerForm>
      }

      {
        updateRequired &&
        <ModalUpdateJobRates rateType="source"
          sourceId={selectedItem?.id}
          onConfirm={jobs => {
            updateJobsSet(jobs);
            confirmedSet(true);
          }}
          onClose={() => {
            updateRequiredSet(false);
          }} />
      }

      {
        confirmRequired &&
        <Modal id="modal-confirmedit-source"
          title="Warning"
          open visible secondModal
          onConfirm={() => {
            confirmedSet(true);
          }}
          onClose={() => confirmRequiredSet(false)}
          buttonText="Confirm & Update"
          buttonColor="warning"
        >
          <div style={{ whiteSpace: "pre" }}>

          </div>
        </Modal>
      }

      {
        deleteModal &&
        <Modal id="modal-delete-source"
          title="Delete Job source"
          buttonText="Delete Source"
          buttonColor="danger"
          open visible
          onClose={() => deleteModalSet(false)}
          onSubmit={(body, callback) => {

            // Never delete on an unknown count — that is exactly how jobs used to end up
            // pointing at a source that no longer exists.
            if (deleteJobsCount == undefined) {
              if (callback) callback();
              return;
            }

            if (deleteJobsCount > 0) {
              if (window.isNullOrEmpty(body.assignTo)) {
                window.formError("assignTo", "Select a source!", "modal-delete-source");
                if (callback) callback();
                return;
              }
            }

            hub.Post(API_ROUTES.JobSources + "delete/" + selectedItem?.id, body, res => {
              if (res.success) {
                refreshSet(true);
                toastSuccess("Job source has been deleted successfully!");
              }
              if (callback) callback(res);
            })

          }}
          secondActionColor="secondary"
          secondActionText="Disable Instead"
          onSecondAction={
            (deleteJobsCount ?? 0) == 0 ? undefined
              : () => {
                hub.Post(API_ROUTES.JobSources + "activetoggle", {
                  id: selectedItem?.id,
                  active: "0"
                }, res => {
                  refreshSet(true);
                  window.closeModal("modal-delete-source");
                })
              }
          }>
          <div>
            {
              deleteJobsCount == undefined ?
                <div className="text-gray-600">
                  <Icon icon="spinner-third" spin />
                  <span className="ms-2">Checking how many jobs use this source...</span>
                </div>
                : deleteJobsCount > 0 ?
                  <div>
                    <div className="text-danger mb-5">
                      There {deleteJobsCount > 1 ? "are" : "is"} {deleteJobsCount} {deleteJobsCount > 1 ? "jobs" : "job"} assigned to this source!
                    </div>
                    <DropDown name="assignTo" apiSource={API_ROUTES.TagifyJobSources + "?excludeIds=" + selectedItem?.id} dataText="title" dataValue="value"
                      label="Assign jobs to*" parentModal="modal-delete-source" labelUp block />
                  </div>
                  :
                  <div>
                    Are you sure you want to delete this job source?
                  </div>
            }

          </div>
        </Modal>
      }



    </>
  );
}

export default JobSourcesList;
